import { makeStyles } from "@material-ui/core/styles";
import TitleBar from "./TitleBar";
import Note from "./Note";
import { getCurrentUser } from "../auth/getCurrentUser";
import {
  AppBar,
  Box,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
  Typography,
  useTheme,
} from "@material-ui/core";
import UserCard from "./UserCard";
import { useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { getAllUsersByName } from "../auth/getAllUsersByName";
import { getFollowerData } from "../auth/getFollowerData";
import Snackbar from "./base/Snackbar";
import { getCurrentUserInfo } from "../auth/getCurrentUserInfo";
import SwipeableViews from "react-swipeable-views";
import BadgePopup from "./Badges/BadgePopup.jsx";
import { getBadgeDetails } from "./Badges/BadgeData.jsx";
import { getGermanDate } from "../lib/utilities.js";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(0, 2),
  },
  margin: {
    marginTop: theme.spacing(1),
  },
  active: {
    color: theme.palette.primary.main,
  },
  usercard: {
    marginBottom: theme.spacing(1),
  },
  follower: {
    padding: theme.spacing(0, 2),
  },
  followerSearch: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(0, 2),
  },
  SearchResult: {
    marginTop: theme.spacing(1),
  },
  scrollContainer: {
    marginBottom: theme.spacing(8),
  },
  info: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  infoIcon: {
    fontSize: "1.5rem",
    marginRight: theme.spacing(1),
  },
  center: {
    textAlign: "center",
    marginTop: "20vh",
  },
}));

function Follow() {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [searchResult, setSearchResult] = useState([]);
  const [currentUser, setCurrentUser] = useState();
  const [isFollower, setIsFollower] = useState(true);
  const [followerData, setFollowerData] = useState({ follower: [], following: [] });
  const [update, setUpdate] = useState(false);
  const [snackbarContent, setSnackbarContent] = useState();
  const [userInfo, setUserInfo] = useState();
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const [value, setValue] = useState(0);
  const [badgeContent, setBadgeContent] = useState({
    open: false,
    title: "",
    text: "",
    id: 1,
    amount: "",
    unit: "",
  });
  const theme = useTheme();

  useEffect(() => {
    const loadInitialFeedData = async () => {
      const currentUser = getCurrentUser();
      const followerData = await getFollowerData(currentUser.id);

      setCurrentUser(currentUser);
      setFollowerData(followerData);
      setIsLoading(false);
    };
    loadInitialFeedData();
  }, [update]);

  useEffect(() => {
    const loadUserInfo = async () => {
      const userInfo = await getCurrentUserInfo();
      setUserInfo(userInfo);
      setIsLoadingUser(false);
    };

    loadUserInfo();
  }, []);

  const onSearch = async () => {
    if (searchTerm.length >= 3) {
      const searchResult = await getAllUsersByName(searchTerm);
      setSearchResult(searchResult);
      if (searchResult.length === 0) {
        setSnackbarContent({
          message: "Keine Treffer",
          status: "info",
          open: true,
        });
      }
    } else {
      setSnackbarContent({
        message: "Für die Suche werden mindestens 3 Zeichen benötigt",
        status: "info",
        open: true,
      });
    }
  };

  const addButtonsToUser = () => {
    const followerArr = followerData.follower;
    const followingArr = followerData.following;

    if (!isFollower) {
      const newFollowingArr = followingArr.map((userObj) => ({
        ...userObj,
        buttons: ["Entfolgen"],
      }));

      return newFollowingArr;
    } else if (isFollower) {
      const newFollowArr = followerArr.map((follower) => {
        if (followingArr.some((following) => following.id === follower.id)) {
          return { ...follower, buttons: ["Löschen"] };
        } else {
          return { ...follower, buttons: ["Folgen", "Löschen"] };
        }
      });
      return newFollowArr;
    }

    return [];
  };

  const renderFollowData = () => {
    const result = addButtonsToUser();
    const infoString = isFollower ? "Du hast noch keine Follower" : "Du folgst niemand";
    const followingArr = followerData.following;
    if (result.length !== 0) {
      return result.map((user, index) => {
        const { userName, id, photoUrl, buttons } = user;
        return (
          <div className={classes.usercard} key={index}>
            <UserCard
              user={{
                userName,
                id,
                photoUrl: photoUrl,
                buttons,
              }}
              currentUserId={currentUser.id}
              update={() => setUpdate(!update)}
              followingAmount={followingArr.length}
              setBadgeContent={setBadgeContent}
              setFollowerData={setFollowerData}
            />
          </div>
        );
      });
    } else {
      return (
        <Typography
          variant="subtitle1"
          color="textSecondary"
          className={`${classes.info} ${classes.center}`}
        >
          <AiOutlineInfoCircle className={classes.infoIcon} /> {infoString}
        </Typography>
      );
    }
  };

  const addButtonsToSearchResults = (searchResult) => {
    const followerArr = followerData.follower;
    const followingArr = followerData.following;

    const newSearchResult = searchResult.map((searchedUser) => {
      if (
        // Wir folgen unserem Follower
        followingArr.some((following) => following.id === searchedUser.id) &&
        followerArr.some((follower) => follower.id === searchedUser.id)
      ) {
        return { ...searchedUser, buttons: ["Entfolgen", "Löschen"] };
      } else if (
        // Wir folgen unserem Follower nicht
        followerArr.some((follower) => follower.id === searchedUser.id) &&
        (followingArr.some((following) => following.id !== searchedUser.id) ||
          followingArr.length === 0)
      ) {
        return { ...searchedUser, buttons: ["Folgen", "Löschen"] };
      } else if (
        // Wir folgen einer Person, die uns nicht Folgt
        followingArr.some((following) => following.id === searchedUser.id) &&
        (followerArr.some((follower) => follower.id !== searchedUser.id) ||
          followerArr.length === 0)
      ) {
        return { ...searchedUser, buttons: ["Entfolgen"] };
      } else if (
        // Wir foglen keiner Person, und sie uns auch nicht
        (followerArr.some((follower) => follower.id !== searchedUser.id) ||
          followerArr.length === 0) &&
        (followingArr.some((following) => following.id !== searchedUser.id) ||
          followingArr.length === 0)
      ) {
        return { ...searchedUser, buttons: ["Folgen"] };
      }

      return { ...searchedUser, buttons: [] };
    });

    return newSearchResult;
  };

  const renderSearchResult = () => {
    const followingArr = followerData.following;

    if (!isLoading) {
      const result = addButtonsToSearchResults(searchResult);
      return result
        .filter((user) => user.id !== currentUser.id)
        .filter((user) => {
          return user.userName.toLowerCase().includes(searchTerm.toLowerCase());
        })
        .map((user, key) => {
          if (searchTerm !== "") {
            const { userName, id, photoUrl, buttons } = user;
            return (
              <div className={classes.usercard} key={key}>
                <UserCard
                  user={{
                    userName,
                    id,
                    photoUrl: photoUrl,
                    buttons: buttons ?? [],
                  }}
                  currentUserId={currentUser.id}
                  update={() => setUpdate(!update)}
                  followingAmount={followingArr.length}
                  setBadgeContent={setBadgeContent}
                  setFollowerData={setFollowerData}
                />
              </div>
            );
          } else {
            return null;
          }
        });
    }
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index) {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
    };
  }

  const handleChange = (e, newValue) => {
    setValue(newValue);
    setIsFollower(!isFollower);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
    setIsFollower(!isFollower);
  };

  return (
    <>
      <div>
        <Snackbar snackbarContent={snackbarContent} setSnackbarContent={setSnackbarContent} />
        <TitleBar title="Folgen" navigateTo={-1} colorPrimary />
        <div className={classes.scrollContainer}>
          {badgeContent.open && (
            <BadgePopup
              open={badgeContent.open}
              badgeDetails={{
                color: getBadgeDetails(badgeContent.id).color,
                title: badgeContent.title,
                longDescription: badgeContent.text,
                icon: getBadgeDetails(badgeContent.id).icon,
              }}
              amount={badgeContent.amount}
              unit={badgeContent.unit}
              achieved={getGermanDate()}
              close={() =>
                setBadgeContent({ open: false, text: "", title: "", amount: "", unit: "", id: 1 })
              }
            />
          )}
          <div className={classes.margin}>
            {!isLoadingUser && (
              <Note
                noteText={`Dein Profil ist ${
                  userInfo.private ? "privat" : "für andere auffindbar"
                }`}
                subText="Ändere deine Präferenz in den Datenschutzeinstellungen"
              />
            )}

            <div className={classes.followerSearch}>
              <TextField
                variant="outlined"
                fullWidth
                placeholder="Suchen"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <AiOutlineSearch onClick={onSearch} />
                    </InputAdornment>
                  ),
                }}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.keyCode === 13) {
                    onSearch();
                  }
                }}
              />
              <div className={classes.SearchResult}>{renderSearchResult()}</div>
            </div>
          </div>
          <AppBar position="static" color="transparent" elevation={0}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="Auswahl der von folgenden Personen"
            >
              <Tab label={`Follower (${followerData.follower.length})`} {...a11yProps(0)} />
              <Tab label={`Folge ich (${followerData.following.length})`} {...a11yProps(1)} />
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction}>
              <div>{!isLoading && renderFollowData()}</div>
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction}>
              <div>{!isLoading && renderFollowData()}</div>
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </>
  );
}

export default Follow;
